import {FC, useEffect, useState} from 'react'
import Content from "../main/Content";
import {postContact} from "../../wordpress/operations/post-contact";
import CheckBox from "../common/Checkbox/Checkbox";
import NavNextPrev from "../common/NavNextPrev/NavNextPrev";

interface Props {
    booking: Booking
    pageContent:ContentPage,
    setBooking: Function,
    content: Content
}

const Contact: FC<Props> = ({ pageContent, booking, setBooking, content }) => {

    const [firstName, setFirstName] = useState(booking.contact.firstname);
    const [lastName, setLastName] = useState(booking.contact.lastname);
    const [phone, setPhone] = useState(booking.contact.phone);
    const [mail, setMail] = useState(booking.contact.mail);
    const [coupon, setCoupon] = useState(booking.contact.coupon);
    const [message, setMessage] = useState(booking.contact.message);

    useEffect(() => {
        window.scrollTo(0, 0)
        postContact(booking)
    }, [])

    const updateField = (e: any) => {
        switch (e.target.name) {
            case 'billing_first_name':
                booking.contact.firstname = e.target.value
                setFirstName(e.target.value)
                break;
            case 'billing_last_name':
                booking.contact.lastname = e.target.value;
                setLastName(e.target.value)
                break;
            case 'billing_phone':
                booking.contact.phone = e.target.value;
                setPhone(e.target.value)
                break;
            case 'billing_email':
                booking.contact.mail = e.target.value;
                setMail(e.target.value)
                break;
            case 'coupon_code':
                booking.contact.coupon = e.target.value;
                setCoupon(e.target.value)
                break;
            case 'order_comments':
                booking.contact.message = e.target.value;
                setMessage(e.target.value)
                break;
        }

        setBooking({
            ...booking,
        })
    }

    const handleCheckBox = (box:string, value:any) => {
        switch (box) {
            case 'marketing':
                booking.contact.marketing = value
                break;
            case 'newsletter':
                booking.contact.newsletter = value
                break;
        }
        setBooking({
            ...booking,
        })
    }

    return (
        <div className="input-outer reg-container">
            <div className="row">
                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 col-xxs-12 z-99">

                </div>
                <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12 col-xxs-12 main-bg">
                    <Content booking={booking} content={pageContent}/>
                    <form id="booking-form" name="checkout" method="post" className="checkout woocommerce-checkout">
                        <div className="form-content">
                            <div className="input-outer">
                                <label>Förnamn <abbr className="required" title="krävs">*</abbr></label>
                                <input id="billing_first_name" type="text" name="billing_first_name" value={firstName}
                                       onChange={updateField}/>
                            </div>
                            <div className="input-outer">
                                <label>Efternamn <abbr className="required" title="krävs">*</abbr></label>
                                <input id="billing_last_name" type="text" name="billing_last_name" value={lastName}
                                       onChange={updateField}/>
                            </div>
                            <div className="input-outer">
                                <label>Telefon <abbr className="required" title="krävs">*</abbr></label>
                                <input id="billing_phone" type="tel" name="billing_phone" value={phone}
                                       onChange={updateField}/>
                            </div>
                            <div className="input-outer">
                                <label>E-post <abbr className="required" title="krävs">*</abbr></label>
                                <input id="billing_email" type="email" name="billing_email" value={mail}
                                       onChange={updateField}/>
                            </div>
                            <div className="input-outer">
                                <label>Kampanjkod</label>
                                <input id="coupon_code" type="text" name="coupon_code" value={coupon}
                                       onChange={updateField}/>
                            </div>
                            <p>Vill du meddela oss något? Eller vill ha hjälp med ytterligare något? Skriv det här så
                                löser vi det.</p>
                            <div className="input-outer">
                                <textarea id="order_comments" rows={4} name="order_comments"
                                          placeholder="Max 500 tecken" value={message} onChange={updateField}/>
                            </div>
                            <CheckBox title={'Jag önskar erbjudanden och marknadsföring från Mechanum.'}
                                      active={booking.contact.marketing} type={'marketing'} handle={handleCheckBox}/>
                            <CheckBox title={'Ja tack, jag vill prenumerera på Mechanums nyhetsbrev.'}
                                      active={booking.contact.newsletter} type={'newsletter'} handle={handleCheckBox}/>
                            <p className={'pt-4'}>Behandlingen av personuppgifter sker i enlighet med aktuella lagar och
                                regler med fokus på att skydda den personliga integriteten när personuppgifterna
                                hanteras. <a href="https://www.mechanum.com/om-oss/integritet/" target={'_blank'} rel="noreferrer">Läs
                                    vår policy</a></p>
                            <div className="btn-booking-submit">
                                <NavNextPrev booking={booking} setBooking={setBooking} content={content}/>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
};

export default Contact
